<template>
  <div class="tradeItem-w">
    <div class="head">
      <div class="picture_w" :style="randomRgb">
        <el-image
          class="picture"
          :src="
            data.cover
              ? data.cover + '!283'
              : require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')
          "
          alt=""
          lazy
        />
      </div>
      <h3 class="title text_ellipsis c_1A1A1A">{{ data.title }}</h3>
    </div>
    <div class="main">
      <div class="desc_item">
        <span class="key_label white_s_nowrap fz14 c_808080">{{
          priceDesc(data.tradeMode)
        }}</span>
        <div class="text_ellipsis c_CF3342">
          <span class="fz20 font_w_bold">
            ￥{{ numTurnText02(data.currentPrice) }}</span
          >
          <span class="fz14" style="margin: 0 0 0 5px">元</span>
          <span v-show="data.priceUnitDesc" class="fz14">{{
            "/" + data.priceUnitDesc
          }}</span>
          <span v-if="data.priceUnit == 'zongjia'" class="fz14 jc"
            >（总价）</span
          >
        </div>
      </div>

      <div
        v-if="data.tradeMode == TradeMode.AUCTION"
        class="desc_item fz14 c_808080"
      >
        <span class="key_label white_s_nowrap">起始价</span>
        <span class="text_ellipsis"
          >￥{{ numTurnText02(data.floorPrice) }}元</span
        >
      </div>

      <!-- 状态时间线 -->
      <div v-if="stateTimeDesc(data)" class="desc_item fz14 c_808080">
        <span style="margin: 0 10px 0 0" v-html="stateTimeDesc(data)" />
        <span v-if="!timeLeft">{{ stateTimeLine(data) }}</span>
        <span v-else class="font_w_bold fz14" style="color:black">
          <span v-if="days" class="time_i">
            <em class="time_num fz12 font_w_bold" style="margin-right:2px">{{ days }}</em
            >天</span
          ><span class="time_i">
            <em class="time_num fz12 font_w_bold" style="margin-right:2px">{{ hours }}</em
            >时</span
          ><span class="time_i"
            ><em class="time_num fz12 font_w_bold" style="margin-right:2px">{{ minutes }}</em
            >分</span
          ><span>
            <em class="time_num fz12 font_w_bold" style="margin-right:2px">{{ seconds }}</em
            >秒</span
          >
        </span>
      </div>
      <!-- 区域，状态 -->
      <div
        class="optional d_flex justify_content_sb align_item_c fz14 c_808080"
      >
        <div class="d_flex align_item_c">
          <i class="el-icon-location-outline fz18" /><span
            class="location_name fz14"
            >{{ data.regionName }}</span
          >
        </div>
        <div class="state fz14 text_center c_fff" :class="stateColor(data)">
          {{ data.stateDesc }}
        </div>
      </div>
    </div>
    <div class="bottom d_flex text_center fz12 c_808080">
      <span class="data_count">{{ data.onlookerCnt }}次围观</span>
      <span v-if="isShowApply" class="data_count"
        >{{ data.applyCnt }}人报名</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  numTurnText,
  numTurnText02,
  formatDate,
  createTimeText,
} from "@/utils";
import { TradeMode } from "@/enums";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      randomRgb: {
        backgroundColor:
          "rgb(" +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          ")",
      },
      showTime: null,
      timeLeft: 0, // 剩余时间（毫秒）
      timer: null, // 定时器
    };
  },
  mounted() {
    this.showTime = this.stateTimeLine(this.data);
    this.startCountdown();
  },
  watch: {
    'data.state': {
      handler(newVal, oldVal) {
        clearInterval(this.timer);
        this.showTime = this.stateTimeLine(this.data);
        this.startCountdown();
        console.log('1111111111')
      },
      deep: true,       // 深度监听（如果 state 是对象/数组）
      immediate: true    // 立即触发一次（可选）
    }
  },
  beforeDestroy() {
    clearInterval(this.timer); // 组件销毁时清除定时器
  },
  computed: {
    ...mapGetters(["priceUnitKey", "stateAllKey"]),
    // 计算天数、小时、分钟、秒
    days() {
      return Math.floor(this.timeLeft / (1000 * 60 * 60 * 24));
    },
    hours() {
      return Math.floor(
        (this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
    },
    minutes() {
      return Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    },
    seconds() {
      return Math.floor((this.timeLeft % (1000 * 60)) / 1000);
    },
    // 状态时间线
    stateTimeLine() {
      return function (data) {
        switch (data.tradeMode) {
          case 0:
            return this.handleDealTimeLine(data);
          case 2:
            return this.handleHistoryTimeLine(data);
          case 3:
            return this.handleAuctionTimeLine(data);
          case 4:
            return this.handleRenewalTimeLine(data);
          case 5:
            return this.handleSmallTimeLine(data);
        }
      };
    },
    // 协商
    handleDealTimeLine() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 6:
            text = data.intentionEndTime;
            break;
          case 4:
          case 5:
            text = data.applyEndTime;
            break;
          case 7:
          case 8:
          case 10:
            text = data.stateEndTime;
            break;
        }
        return text;
      };
    },
    // 小额
    handleSmallTimeLine() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 5:
            // if(new Date().getTime() < new Date(data.applyStartTime).getTime()){
            //   text = data.applyStartTime
            // }else{
            //   text = data.applyEndTime
            // }
            text = data.applyEndTime;
            break;

          case 4:
          case 7:
          case 8:
          case 10:
            text = data.stateEndTime;
        }
        return text;
      };
    },
    // 竞拍
    handleAuctionTimeLine() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 3:
            text = data.applyStartTime;
            break;
          case 4:
            text = data.applyEndTime;
            break;
          case 5:
            text = data.auctionStartTime;
            break;
          case 6:
            text = data.auctionEndTime;
            break;
          case 7:
          case 8:
          case 9:
          case 10:
            text = data.stateEndTime;
            break;
        }
        return text;
      };
    },
    // 续约
    handleRenewalTimeLine() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 5:
            text = data.applyEndTime;
            break;
          case 6:
            text = data.intentionEndTime;
            break;
          case 4:
          case 7:
          case 8:
          case 10:
            text = data.stateEndTime;
            break;
        }
        return text;
      };
    },
    // 历史
    handleHistoryTimeLine() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 3:
            text = "";
            break;
          case 4:
            text = data.stateEndTime;
            break;
        }
        return text;
      };
    },

    // 状态时间文本
    stateTimeDesc() {
      return function (data) {
        switch (data.tradeMode) {
          case 0:
            return this.handleDealStateKey(data);
          case 1:
          case 2:
            return this.handleHistoryStateKey(data.state);
          case 3:
            return this.handleAuctionStateKey(data.state);
          case 4:
            return this.handleRenewalStateKey(data.state);
          case 5:
            return this.handleSmallStateKey(data);
        }
      };
    },
    // 协商
    handleDealStateKey() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 4:
          case 7:
          case 8:
          case 10:
            text = "结&nbsp;&nbsp;束";
            break;
          case 5:
            text = "距截止";
            break;
          case 6:
            // if(new Date().getTime() < new Date(data.applyStartTime).getTime()){
            //   text = '距开始'
            // }else{
            //   text = "距结束";
            // }
            text = "距结束";
            break;
        }
        return text;
      };
    },
    // 小额交易
    handleSmallStateKey() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 5:
            // if(new Date().getTime() < new Date(data.applyStartTime).getTime()){
            //   text = '距开始'
            // }else{
            //   text = "距截止";
            // }
            text = "距截止";
            break;
          case 4:
          case 7:
          case 8:
          case 10:
            text = "结&nbsp;&nbsp;束";
            break;
        }
        return text;
      };
    },
    // 竞拍
    handleAuctionStateKey() {
      return function (state) {
        let text = "";
        switch (state) {
          case 0:
          case 1:
          case 2:
          case 3:
            text = "距开始";
            break;
          case 4:
            text = "距截止";
            break;
          case 5:
            text = "距开始";
            break;
          case 6:
            text = "距结束";
            break;
          case 7:
          case 8:
          case 9:
          case 10:
            text = "结&nbsp;&nbsp;束";
            break;
        }
        return text;
      };
    },
    // 续约
    handleRenewalStateKey() {
      return function (state) {
        let text = "";
        switch (state) {
          case 4:
          case 7:
          case 8:
          case 10:
            text = "结&nbsp;&nbsp;束";
            break;
          case 6:
            text = "距结束";
            break;
        }
        return text;
      };
    },
    // 历史
    handleHistoryStateKey() {
      return function (state) {
        let text = "";
        switch (state) {
          case 3:
            text = "";
            break;
          case 4:
            text = "结&nbsp;&nbsp;束";
            break;
        }
        return text;
      };
    },

    // 状态颜色
    stateColor() {
      return function (data) {
        switch (data.tradeMode) {
          case 0:
            return this.handleDealStateColor(data.state);
          case 2:
            return this.handleHistoryStateColor(data.state);
          case 3:
            return this.handleAuctionStateColor(data.state);
          case 4:
            return this.handleRenewalStateColor(data.state);
          case 5:
            return this.handleSmallStateColor(data.state);
        }
      };
    },
    // 协商
    handleDealStateColor() {
      return function (state) {
        let text = "";
        switch (state) {
          case 11:
            text = "bc_FFB03F";
            break;
          case 5:
            text = "bc_22D179";
            break;
          case 6:
            text = "bc_EF3946";
            break;
          case 1:
          case 3:
          case 4:
          case 7:
          case 8:
          case 10:
            text = "bc_808080";
            break;
        }
        return text;
      };
    },
    // 小额
    handleSmallStateColor() {
      return function (state) {
        let text = "";
        switch (state) {
          case 5:
            text = "bc_22D179";
            break;
          case 1:
          case 3:
          case 4:
          case 7:
          case 8:
          case 10:
            text = "bc_808080";
            break;
        }
        return text;
      };
    },
    // 竞拍
    handleAuctionStateColor() {
      return function (stateCode) {
        switch (stateCode) {
          case 0:
          case 1:
          case 3:
          case 4:
            return "bc_22D179";
          case 6:
            return "bc_EF3946";
          case 2:
          case 5:
            return "bc_808080";
          default:
            return "bc_808080";
        }
      };
    },
    // 续约
    handleRenewalStateColor() {
      return function (state) {
        let text = "";
        switch (state) {
          case 6:
            text = "bc_EF3946";
            break;
          case 1:
          case 3:
          case 4:
          case 7:
          case 8:
          case 10:
            text = "bc_808080";
            break;
        }
        return text;
      };
    },
    // 历史
    handleHistoryStateColor() {
      return function (state) {
        let text = "";
        switch (state) {
          case 3:
            text = "bc_22D179";
            break;
          case 4:
            text = "bc_808080";
            break;
        }
        return text;
      };
    },

    // 格式化金额（中文）
    numTurnText: function () {
      return function (num) {
        return numTurnText(num);
      };
    },

    // 格式化金额（中文）
    numTurnText02: function () {
      return function (num) {
        return numTurnText02(num);
      };
    },
    // 价格名称(中文)
    priceDesc: function () {
      return function (tradeMode) {
        switch (tradeMode) {
          case TradeMode.AUCTION:
            return "当前价";
          default:
            return "挂牌价";
        }
      };
    },
    TradeMode: function () {
      return TradeMode;
    },
    isShowApply() {
      return [
        TradeMode.DEAL,
        TradeMode.AUCTION,
        TradeMode.SMALL_SIMPLE,
      ].includes(this.data.tradeMode);
    },
  },
  methods: {
    startCountdown() {
      const targetDate = new Date(this.showTime).getTime(); // 目标时间戳

      this.timer = setInterval(() => {
        const now = new Date().getTime();
        this.timeLeft = targetDate - now;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          this.timeLeft = 0;
        }

      }, 1000); // 每秒更新一次
    },
  },
};
</script>

<style lang="scss" scoped>
.time_i {
  margin: 0 2px 0 0;
}
.tradeItem-w {
  display: flex;
  flex-direction: column;
  width: 285px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  &:nth-child(4n) {
    margin: 0 0 20px 0;
  }
  &:hover {
    cursor: pointer;
  }
  .head {
    .picture_w {
      position: relative;
      height: 150px;
    }
    .picture {
      ::v-deep img {
        position: static; // 兼容ie
        display: block;
        width: 283px;
        height: 150px;
        transform: none; // 兼容ie
      }
    }
    .title {
      padding: 15px;
    }
  }
  .main {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 15px;
    border-top: 1px solid #e6e6e6;
    .desc_item {
      display: flex;
      align-items: center;
      margin: 0 0 15px 0;
      .time {
        margin-left: 10px;
      }
    }
    .key_label {
      margin-right: 8px;
    }
    .state {
      height: 26px;
      line-height: 26px;
      margin-right: -16px;
      padding: 0 14px;
    }
    .optional {
      margin-top: auto;
      .location_name {
        margin-left: 6px;
      }
    }
  }
  .bottom {
    margin-top: auto;
    border-top: 1px solid #e6e6e6;
    .data_count {
      margin: 10px 0;
      flex: 1;
      border-right: 1px solid #dbd5d5;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.jc {
  font-weight: 500;
}
</style>
